<template>
  <div class="flex flex-col h-full overflow-y-hidden">
    <form @submit.prevent="handleSubmit(handleProceed)()">
      <div class="form-fields">
        <div class="flex w-11/12 h-16 mx-auto">
          <VFormInput
            placeholder="Enter new product group name"
            label="Add New Group*"
            @update="value => handleSetField('name', value)"
            :error="errors.name"
            :initialValue="editableGroup.name"
            :reset="!fieldsData.name"
            :classes="{ field: 'mb-0 flex-1 mr-8' }"
          />
          <VFormSelect
            placeholder="Select "
            label="Required Pre-Training*"
            :options="requiredPreTraining"
            optionKey="name"
            :initialSelectedOption="
              editableGroup.required != undefined ? editableGroup.required : ''
            "
            :error="errors.required_pretraining"
            :classes="{ fieldContainer: 'mr-8' }"
            @onSelect="value => handleSetField('required_pretraining', value.id)"
          />
          <VFormSelect
            placeholder="Select"
            label="Has Training*"
            :options="hasTraining"
            optionKey="name"
            :initialSelectedOption="
              editableGroup.has_training != undefined ? editableGroup.has_training : ''
            "
            :error="errors.has_training"
            :classes="{ fieldContainer: 'mr-8' }"
            @onSelect="value => handleSetField('has_training', value.id)"
          />
          <VFormSelect
            placeholder="Select"
            label="Requires rep approval*"
            :options="requiresRepApproval"
            optionKey="name"
            :initialSelectedOption="
              editableGroup.requires_rep_approval != undefined
                ? editableGroup.requires_rep_approval
                : ''
            "
            :error="errors.requires_rep_approval"
            :classes="{ fieldContainer: 'mr-8' }"
            @onSelect="value => handleSetField('requires_rep_approval', value.id)"
          />
          <VFormSelect
            placeholder="Select group category"
            label="Group Category*"
            :options="category"
            optionKey="name"
            :initialSelectedOption="
              editableGroup.category_id != undefined ? editableGroup.category_id : ''
            "
            :error="errors.category_id"
            :classes="{ fieldContainer: 'mr-8' }"
            @onSelect="value => handleSetField('category_id', value.id)"
          />
          <button type="submit" class="w-4/12 ml-6 text-white bg-gray-900 rounded">
            {{ editable ? 'EDIT' : 'ADD' }}
          </button>
        </div>
      </div>
    </form>
    <ul class="px-5 overflow-y-auto">
      <li
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 font-bold text-center">Name</div>
        <div class="w-3/12 font-bold text-center">Required Pretraining</div>
        <div class="w-3/12 font-bold text-center">Has Training</div>
        <div class="w-3/12 font-bold text-center">Requires rep approval</div>
        <div class="w-3/12 font-bold text-center">Group</div>
        <div class="w-3/12 font-bold text-center">Actions</div>
      </li>
      <li
        v-for="(serie, index) in series"
        :key="`serie-${index}`"
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 text-center">{{ serie.name }}</div>
        <div class="w-3/12 text-center">{{ modifyRequiredValue(serie.required) }}</div>
        <div class="w-3/12 text-center">{{ modifyRequiredValue(serie.has_training) }}</div>
        <div class="w-3/12 text-center">{{ modifyRequiredValue(serie.requires_rep_approval) }}</div>
        <div class="w-3/12 text-center">{{ serie.category_name }}</div>
        <div class="flex justify-center w-3/12">
          <button class="mr-2 button-round edit" @click="handleSetEditable(serie)">
            <VSvgIcon name="pencil" class="h-5" />
          </button>
          <button class="button-round delete" @click="handleDeleteGroup(serie.id)">
            <VSvgIcon name="trash" class="h-5" />
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { formMixin } from '@/mixins';

import VFormInput from '@/components/base/VFormInput';
import VFormSelect from '@/components/base/VFormSelect';
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'ProductGroupForm',
  components: {
    VFormInput,
    VFormSelect,
    VSvgIcon,
  },
  props: {
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    series: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  mixins: [
    formMixin({
      name: '',
      required_pretraining: '',
      has_training: '',
      category_id: '',
    }),
  ],
  data() {
    return {
      requiredPreTraining: [
        { id: 1, name: 'YES' },
        { id: 0, name: 'NO' },
      ],
      hasTraining: [
        { id: 1, name: 'YES' },
        { id: 0, name: 'NO' },
      ],
      requiresRepApproval: [
        { id: 1, name: 'YES' },
        { id: 0, name: 'NO' },
      ],
      category: this.$store.state.admin.groupCategories.data,
      editableGroup: {},
    };
  },
  computed: {
    seriesOptions() {
      return this.series.map(serie => serie.name);
    },
    editable() {
      return this.editableGroup && !!Object.keys(this.editableGroup).length;
    },
  },
  methods: {
    modifyRequiredValue(value) {
      return value ? 'YES' : 'NO';
    },
    handleSetEditable({ required, has_training, requires_rep_approval, category_id, ...res }) {
      this.editableGroup = {
        ...res,
        required: this.requiredPreTraining.find(({ id }) => id === required),
        has_training: this.hasTraining.find(({ id }) => id === has_training),
        requires_rep_approval: this.requiresRepApproval.find(
          ({ id }) => id === requires_rep_approval,
        ),
        category_id: this.category.find(({ id }) => id === category_id),
      };
    },
    handleReset() {
      this.handleResetFields();
      this.handleResetErrors();
      this.editableGroup = {};
    },
    async handleAddGroup({
      name,
      required_pretraining,
      has_training,
      requires_rep_approval,
      category_id,
    }) {
      await this.$store.dispatch('admin/addSerie', {
        name: name,
        required: required_pretraining,
        has_training: has_training,
        category_id: category_id,
        requires_rep_approval: requires_rep_approval,
      });
      this.handleReset();
    },
    async handleUpdateGroup({
      id,
      name,
      required_pretraining,
      has_training,
      requires_rep_approval,
      category_id,
    }) {
      await this.$store.dispatch('admin/updateSerie', {
        id,
        name,
        required: required_pretraining,
        has_training,
        category_id,
        requires_rep_approval,
      });
      this.handleReset();
    },
    async handleDeleteGroup(id) {
      await this.$store.dispatch('admin/deleteSerie', id);
    },
    handleProceed(data) {
      this.editable
        ? this.handleUpdateGroup({
            id: this.editableGroup.id,
            name: data.name,
            required_pretraining: data.required_pretraining,
            has_training: data.has_training,
            requires_rep_approval: data.requires_rep_approval,
            category_id: data.category_id,
          })
        : this.handleAddGroup(data);
    },
  },
};
</script>
